import { ErrorType } from "@components/global/new/Error/Error";
import { LoginWith2FaRequest } from "@services/auth";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { Reset2FaRequest } from "@services/twoFa";
import { RootDispatch } from "@store";
import { logon } from "@store/auth/actions";
import { makeNotifs } from "@utils/makeNotifs";
import { ROUTES_E } from "@utils/RoutsName";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITwoFaModalProps } from "./TwoFaModal";
import { useToasts } from "@utils/hooks/useToasts";
import { AccountRecord } from "@services/http/responses/AccountResponse";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

interface Elems extends HTMLFormControlsCollection {
  // email: HTMLInputElement;
  // password: HTMLInputElement;
  Code2FA: HTMLInputElement;
  ResetCode: HTMLInputElement;
}

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

interface TwoFaModalControlI {
  readonly resetFa: boolean;
  readonly loading: boolean;
  readonly error?: ErrorType;

  //ref
  recapRef: any;

  onChangeWindow(): void;
  formControl(e: React.FormEvent<MyForm>): void;
  onCloseHandler(): void;
  setRecaptchaResponse(r: string | undefined): void;
}

export const useTwoFaModalControl = (
  props: ITwoFaModalProps
): TwoFaModalControlI => {
  const recapRef = useRef<any>(null);
  const { onLoader } = useGlobalNotifs();
  const requests = useApiRequests();
  const { success } = useToasts();
  const { errors, ok } = makeNotifs();
  const navigate = useNavigate();
  const dispatch = useDispatch() as RootDispatch;
  const [resetFa, setResetFa] = useState<boolean>(false);
  const [error, setError] = useState<ErrorType>();
  const [recaptchaResponse, setRecaptchaResponse] = useState<
    string | undefined
  >();

  const onChangeWindow = () => setResetFa((prev) => !prev);

  const onConfirm2Fa = async (e: React.FormEvent<MyForm>) => {
    const elems = e.currentTarget.elements;
    const Code2FA = elems.Code2FA.value;
    if (!Code2FA) {
      setError({ ownError: [errors.fill] });
      return;
    }
    const response = await requests.enqueue<RecordResponse<AccountRecord>>(
      new LoginWith2FaRequest(Code2FA),
      {
        onLoadingStatusChanged: onLoader,
      }
    );
    if (!response) return;
    props.handleClose();
    dispatch(logon(response.Record));
    navigate(ROUTES_E.MACHINES);
  };

  const onConfirmReset2Fa = async (e: React.FormEvent<MyForm>) => {
    const elems = e.currentTarget.elements;
    const ResetCode = elems.ResetCode?.value;
    const recaptcha = recaptchaResponse;
    // const email = elems.email.value.replace(/\s+/g, "");
    // const password = elems.password.value;

    if (!ResetCode || !recaptcha) {
      setError({ ownError: [errors.fill] });
      return;
    }

    const response = await requests.enqueue(
      new Reset2FaRequest({
        reset_code: ResetCode,
        recaptcha,
        email: props.email,
        password: props.password,
      }),
      {
        onLoadingStatusChanged: onLoader,
      }
    );
    if (!response) return;

    success(ok.check_email);
    props.handleClose();
  };

  const formControl = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    setError(undefined);

    if (resetFa) {
      onConfirmReset2Fa(e);
    } else {
      onConfirm2Fa(e);
    }
  };

  const onCloseHandler = () => {
    props.handleClose();
  };

  return {
    resetFa,
    loading: requests.isLoading,
    error,
    recapRef,

    onChangeWindow,
    formControl,
    onCloseHandler,
    setRecaptchaResponse,
  };
};
